module.exports = __webpack_public_path__ + "img/dial-low.844c3b81.svg";